import { Component, OnInit, Input, Output, EventEmitter, ViewChild, AfterViewChecked } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { EliminarEntidadComponent } from '../../../helpers/components/deleteEntity/deleteEntity.component';
import { OutputModel } from 'app/infrastructure/model/classes/output.classes';

@Component({
  selector: 'sx-home-output',
  templateUrl: './home.output.component.html',
  styleUrls: ['./home.output.component.css']
})
export class HomeOutputComponent implements OnInit, AfterViewChecked {
  @ViewChild(EliminarEntidadComponent) eliminarEntidad: EliminarEntidadComponent;

  @Input('output') output: OutputModel;
  @Input('codSistema') codSistema: String;
  @Input('esNuevo') esNuevo: boolean;
  @Input('checkeandCodigo') checkeandCodigo: boolean;
  @Input('errorCodigo') errorCodigo: string;
  @Input('completitud') completitud: number;

  @Output('descripcionEditada') descripcionEditada: EventEmitter<string> = new EventEmitter();
  @Output('createOutput') createOutput: EventEmitter<string> = new EventEmitter();

  outputCode: String;

  constructor(private router: Router, private route: ActivatedRoute) { }

  ngOnInit() {
    this.outputCode = this.output.outputCode;
  }

  ngAfterViewChecked() {
    if (this.eliminarEntidad) {
      this.eliminarEntidad.eliminado.subscribe(eliminado => this.onDelete(eliminado));
    }
  }

  editarDescripcion(descripcion) {
    this.descripcionEditada.emit(descripcion);
  }

  confirmOutput() {
    this.createOutput.emit();
  }

  onDelete(param) {
    this.router.navigate(['../'], { relativeTo: this.route });
  }

  configuration() {
    this.router.navigate(['confOutput'], { relativeTo: this.route });
  }
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/outputs/home/home.output.component.ts